<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="hidden">
  <section class="row bg-brown">
    <div class="col-lg-4 col-md-3 col-sm-12 pr-0">
      <div class="upload-progress-section">
        <div class="text-center">
          <div>
            <img src="assets/images/adult.jpg" alt="" />
          </div>
          <h2 class="text-white mt-3">
            “Good questions make readers think out of the Box.” <br />
            <b><em> ―QSL</em></b>
          </h2>
        </div>
        <div class="mt-auto container font14 text-grey">
          Please complete the quiz creation process correctly
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-3 col-sm-12 bg-white">
      <div class="container">
        <div class="my-5">
          <div class="question-box">
            <div class="mb-2">
              <p class="mb-3 font24 text-grey">Quiz Title</p>
              <form action="" [formGroup]="quizForm">
                <input
                  placeholder="Enter Quiz Title"
                  class="common-input bg-white w-100"
                  formControlName="name"
                  [ngClass]="{
                    'is-invalid':
                      quizForm.get('name').errors &&
                      quizForm.get('name').touched
                  }"
                />
                <div class="invalid-feedback mt-0 p-0">
                  Please enter content title
                </div>
                <p class="mb-3 mt-3 font24 text-grey">Content Description</p>
                <angular-editor
                  [placeholder]="'Enter text here...'"
                  formControlName="description"
                  [config]="config"
                  [ngClass]="{
                    'is-invalid':
                      quizForm.get('description').errors &&
                      quizForm.get('description').touched
                  }"
                ></angular-editor>
                <div class="invalid-feedback mt-0 p-0">
                  Please describe this content
                </div>
                <span class="font14 font-light text-grey">
                  Let participants know a little about your course in 500
                  characters or less.
                </span>
              </form>

              <div
                class="mt-4 font14 font-light d-flex justify-content-between align-items-center"
              >
                <p class="font20">
                  Use the quiz creator to create a multiple choice quiz. You may
                  only have 1 quiz per Lesson.
                </p>
              </div>
            </div>
            <form action="" [formGroup]="quizQuestioForm">
              <div class="px-5 pb-5 pt-0">
                <div formArrayName="questions">
                  <div
                    class="my-4"
                    [formGroupName]="i"
                    *ngFor="
                      let question of getQuizQuestion.controls;
                      index as i
                    "
                  >
                    <div class="d-flex align-items-center">
                      <div class="mr-3 option-number">0{{ i + 1 }}</div>
                      <div class="row w-100">
                        <div class="col-lg-12 col-sm-12">
                          <input
                            type="text"
                            class="common-input bg-white w-100"
                            placeholder="Enter Question {{
                              transformNumber(i + 1)
                            }}"
                            formControlName="title"
                            [ngClass]="{
                              'is-invalid':
                                question.get('title').errors &&
                                question.get('title').touched
                            }"
                          />
                        </div>
                      </div>
                    </div>
                    <div formArrayName="answers">
                      <div
                        *ngFor="
                          let answer of question.get('answers')['controls'];
                          index as j
                        "
                        [formGroupName]="j"
                        class="my-4 d-flex align-items-center"
                      >
                        <div class="mr-3 font-bold option-number">
                          {{ transformString(j) }}
                        </div>
                        <div class="row w-100">
                          <div class="col-lg-8 col-sm-12">
                            <input
                              type="text"
                              class="common-input bg-white w-100"
                              placeholder="Enter Option {{
                                transformString(j)
                              }}"
                              formControlName="title"
                              [ngClass]="{
                                'is-invalid':
                                  answer.get('title').errors &&
                                  answer.get('title').touched
                              }"
                            />
                          </div>
                          <div class="col-lg-4 col-sm-12 sm-mt">
                            <select
                              type="text"
                              class="common-input bg-white w-100"
                              formControlName="isAnswer"
                            >
                              <option [ngValue]="true">correct</option>
                              <option [ngValue]="false">incorrect</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      class="btn-sm btn-outline-danger"
                      (click)="removeQuestion(i)"
                    >
                      Remove
                    </button>
                    <hr />
                  </div>
                </div>
                <div class="mt-5 pb-5 d-flex justify-content-between">
                  <button class="btn-sm btn-secondary" (click)="addQuestion()">
                    Add Quiz Question
                  </button>
                  <div class="d-flex justify-content-end">
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      (click)="addContent('page')"
                    >
                      Save and add more
                    </button>
                    <button
                      class="btn-md py-2 btn-primary ml-2"
                      (click)="finish()"
                      [disabled]="quizQuestioForm.invalid"
                    >
                      finish
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
